module.exports = __webpack_public_path__ + "media/images/area/feature/setouchi/related/en/3-b32c464667c9a49981d0a1de033dee8c.jpg";